import React from 'react';
import SEO from './SEO';
import { Link } from 'react-router-dom';
import './PoliticaPrivacidade.css';

const PoliticaPrivacidade = () => {
  return (
    <div className="politica-page">
      <SEO
        title="Política de Privacidade - Veritux ERP"
        description="Política de privacidade da MNGD / Veritux ERP: quais dados coletamos, como usamos, seus direitos pela LGPD e como solicitar a exclusão dos seus dados."
        keywords="política de privacidade, LGPD, proteção de dados, exclusão de dados, Veritux ERP"
        url="https://www.veritux.com.br/politica-de-privacidade"
      />

      <header className="politica-header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src="/Logo.ico" alt="Veritux ERP" className="logo-img" />
              <span className="logo-text">Veritux ERP</span>
            </Link>
            <nav className="nav">
              <Link to="/funcionalidades">Funcionalidades</Link>
              <Link to="/downloads">Downloads</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="politica-content">
        <div className="container">
          <h1>Política de Privacidade</h1>
          <p className="politica-atualizacao">Última atualização: 24 de julho de 2026</p>

          <p>
            A MNGD Tecnologia e Gestão (&quot;MNGD&quot;, &quot;nós&quot;), desenvolvedora do sistema
            Veritux ERP, respeita a sua privacidade e trata dados pessoais em conformidade com a
            Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD). Esta política explica
            quais dados coletamos, por que coletamos e quais são os seus direitos.
          </p>

          <h2>1. Quais dados coletamos</h2>
          <h3>No site e páginas do Veritux</h3>
          <ul>
            <li>
              Dados de contato fornecidos por você em formulários (nome, e-mail, telefone/WhatsApp,
              nome da empresa) ao solicitar teste grátis, demonstração ou contato comercial.
            </li>
            <li>
              Dados de navegação coletados por cookies e tecnologias similares (páginas visitadas,
              origem do acesso, dispositivo), inclusive por ferramentas de análise e publicidade
              como Google Analytics e Meta Pixel.
            </li>
          </ul>
          <h3>No sistema Veritux ERP (clientes)</h3>
          <ul>
            <li>Dados cadastrais da empresa contratante e de seus usuários (nome, e-mail, CNPJ).</li>
            <li>
              Dados operacionais inseridos pelo cliente no uso do sistema (cadastros, vendas,
              estoque, financeiro, documentos fiscais). Em relação a esses dados, a MNGD atua como
              <strong> operadora</strong>: o cliente é o controlador e responsável pelas informações
              que insere.
            </li>
          </ul>

          <h2>2. Para que usamos os dados</h2>
          <ul>
            <li>Fornecer, operar e dar suporte ao Veritux ERP.</li>
            <li>Responder solicitações de contato, teste grátis e demonstração.</li>
            <li>Emitir cobranças e cumprir obrigações legais e fiscais.</li>
            <li>Melhorar o site e divulgar o produto, inclusive por anúncios direcionados (Google/Meta).</li>
            <li>Enviar comunicações sobre o produto — sempre com opção de descadastro.</li>
          </ul>

          <h2>3. Base legal</h2>
          <p>
            Tratamos dados com base em: execução de contrato (art. 7º, V), consentimento
            (art. 7º, I), legítimo interesse (art. 7º, IX) e cumprimento de obrigação legal
            (art. 7º, II) da LGPD.
          </p>

          <h2>4. Compartilhamento</h2>
          <p>
            Não vendemos dados pessoais. Compartilhamos dados apenas com: provedores de
            infraestrutura e serviços essenciais (hospedagem, e-mail, meios de pagamento, emissão
            fiscal), plataformas de análise e publicidade (Google, Meta) nos limites desta
            política, e autoridades quando exigido por lei.
          </p>

          <h2>5. Armazenamento e segurança</h2>
          <p>
            Os dados são armazenados em ambientes com controle de acesso, criptografia em trânsito
            e backups. Dados de clientes que cancelam o serviço permanecem disponíveis para
            exportação por 30 dias após o cancelamento; depois desse prazo são excluídos ou
            anonimizados, ressalvadas as retenções exigidas por lei (ex.: documentos fiscais).
          </p>

          <h2 id="exclusao-de-dados">6. Exclusão de dados e direitos do titular</h2>
          <p>Você pode solicitar, a qualquer momento:</p>
          <ul>
            <li>confirmação e acesso aos seus dados;</li>
            <li>correção de dados incompletos ou desatualizados;</li>
            <li><strong>exclusão dos seus dados pessoais</strong>;</li>
            <li>portabilidade e informação sobre compartilhamentos;</li>
            <li>revogação de consentimento.</li>
          </ul>
          <p>
            <strong>Como solicitar a exclusão dos seus dados:</strong> envie um e-mail para{' '}
            <a href="mailto:contato@veritux.com.br?subject=Exclus%C3%A3o%20de%20dados">
              contato@veritux.com.br
            </a>{' '}
            com o assunto &quot;Exclusão de dados&quot;, informando o nome e o e-mail/telefone
            usados no cadastro. Confirmaremos a identidade do solicitante e concluiremos a exclusão
            em até 15 dias, comunicando quando houver dados cuja retenção seja obrigatória por lei.
          </p>
          <p>
            Se você interagiu com nossos perfis em redes sociais (ex.: Instagram) ou com apps
            conectados da MNGD, a mesma solicitação por e-mail cobre a exclusão dos dados sob
            nosso controle.
          </p>

          <h2>7. Cookies</h2>
          <p>
            Você pode desativar cookies no navegador. Para anúncios, é possível ajustar
            preferências nas configurações do Google e da Meta.
          </p>

          <h2>8. Contato do encarregado (DPO)</h2>
          <p>
            Dúvidas sobre esta política ou sobre dados pessoais:{' '}
            <a href="mailto:contato@veritux.com.br">contato@veritux.com.br</a>.
          </p>

          <h2>9. Alterações</h2>
          <p>
            Esta política pode ser atualizada; a versão vigente estará sempre nesta página, com a
            data de atualização no topo.
          </p>
        </div>
      </main>

      <footer className="politica-footer">
        <div className="container">
          <p>© {new Date().getFullYear()} MNGD Tecnologia e Gestão · Veritux ERP</p>
          <Link to="/">Voltar ao site</Link>
        </div>
      </footer>
    </div>
  );
};

export default PoliticaPrivacidade;
